import { c as _c } from "react/compiler-runtime";
import { ArrowDownIcon } from '@systemeio/ui/icons';
import { ActionMenu, ActionMenuItem, PrimaryButton } from '@systemeio/ui';
import React, { useState, type JSX } from 'react';
import { ButtonWithDropdownTypeEnum } from 'shared/components/buttin-with-dropdown/enums/button-with-dropdown-type-enum';
import { ButtonWithDropdownOptionsType, ButtonWithDropdownStateType } from 'shared/components/buttin-with-dropdown/types/button-with-dropdown-interface';
import { ActionMenuLinkItem } from 'shared/components/table/components/action-menu-link-item';
import { twJoin, twMerge } from 'tailwind-merge';
export interface ButtonWithDropdown {
  options: ButtonWithDropdownOptionsType[];
  disabled: boolean;
  onClick: () => Promise<void>;
  title: string;
  isFetching: boolean;
}
export const ButtonWithDropdown = t0 => {
  const $ = _c(29);
  const {
    options,
    onClick,
    disabled,
    title,
    isFetching
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = () => {
      const obj = {} as ButtonWithDropdownStateType;
      options.forEach(value => {
        obj[value.name] = false;
      });
      return obj;
    };
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [isOpened, setIsOpened] = useState(t1);
  let actionSideElements;
  let items;
  let t2;
  if ($[2] !== isOpened || $[3] !== options) {
    actionSideElements = [];
    const itemRender = el => {
      const shouldRender = el.shouldRender !== undefined ? el.shouldRender : true;
      if (shouldRender) {
        switch (el.type) {
          case ButtonWithDropdownTypeEnum.Button:
            {
              actionSideElements.push(el.onActionRender(isOpened[el.name] ?? false, () => setIsOpened(prev => ({
                ...prev,
                [el.name]: false
              })), `${el.name}-modal`));
              return <ActionMenuItem key={`${el.name}-custom`} disabled={el.menuItem?.disabled} className={twMerge("px-3 py-2.5 text-[15px] font-medium lg:px-4 lg:py-3.5", !el.menuItem?.disabled && "text-text-primary")} onClick={async () => {
                setIsOpened(prev_0 => ({
                  ...prev_0,
                  [el.name]: true
                }));
              }} label={<div className="flex gap-2">{el.menuItem?.icon}<span className="truncate">{el.menuItem.title}</span></div>} />;
            }
          case ButtonWithDropdownTypeEnum.Link:
            {
              return <ActionMenuLinkItem isNext={el.isNext} openInNew={el.openInNew} key={`${el.name}-open-link`} href={el.setHref()} disabled={el.menuItem?.disabled} className={twMerge("px-3 py-2.5 text-[15px] font-medium lg:px-4 lg:py-3.5", !el.menuItem?.disabled && "text-text-primary")} label={<>{el.menuItem?.icon}<span className="truncate">{el.menuItem.title}</span></>} />;
            }
        }
      }
    };
    items = options.map(el_0 => itemRender(el_0));
    t2 = items.filter(Boolean);
    $[2] = isOpened;
    $[3] = options;
    $[4] = actionSideElements;
    $[5] = items;
    $[6] = t2;
  } else {
    actionSideElements = $[4];
    items = $[5];
    t2 = $[6];
  }
  const hasItems = t2.length !== 0;
  const t3 = disabled && "bg-text-secondary/50 pointer-events-none";
  let t4;
  if ($[7] !== t3) {
    t4 = twJoin(t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `bg-brand-primary flex rounded-lg ${t4}`;
  const t6 = hasItems && "rounded-r-none";
  let t7;
  if ($[9] !== t6) {
    t7 = twJoin(t6);
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onClick) {
    t8 = () => onClick();
    $[11] = onClick;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== disabled || $[14] !== isFetching || $[15] !== t7 || $[16] !== t8 || $[17] !== title) {
    t9 = <PrimaryButton className={t7} isFetching={isFetching} disabled={disabled} onClick={t8}>{title}</PrimaryButton>;
    $[13] = disabled;
    $[14] = isFetching;
    $[15] = t7;
    $[16] = t8;
    $[17] = title;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== hasItems || $[20] !== items) {
    t10 = hasItems && <ActionMenu menuItems={items}>{_temp}</ActionMenu>;
    $[19] = hasItems;
    $[20] = items;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== actionSideElements) {
    t11 = actionSideElements.map(_temp2);
    $[22] = actionSideElements;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t5 || $[27] !== t9) {
    t12 = <div className={t5}>{t9}{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t5;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
function _temp(t0) {
  const {
    active
  } = t0;
  return <div className="main-transition-colors hover:bg-brand-primary-hover border-l-background-secondary rounded-r-lg  border-l p-4 "><ArrowDownIcon className={twMerge("stroke-background-secondary transition-transform duration-300", active && "rotate-180")} aria-hidden="true" /></div>;
}
function _temp2(el_1) {
  return <div key={el_1.key}>{el_1}</div>;
}